import PropTypes from 'prop-types';
import { memo } from 'react';

import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';
import Tooltip from 'shopper/components/Tooltip';

import placeholder from 'lib/placeholder';

import Keywords from './Keywords';

const WishlistSuggestions = ({ gaEventCategory, keywords }) => (
  <div className="flex flex-col gap-4 lg:mb-14">
    <Heading
      as="h2"
      className="flex items-center text-neutral-low-300 dark:text-neutral-high-300"
      size="size5"
    >
      {placeholder('titles.wishlistKeywordsSuggestions')}
      <Tooltip.Root>
        <Tooltip.Trigger>
          <button className="flex size-10 items-center justify-center">
            <Icon className="text-rd-primary-700" name="info" size="size2" />
          </button>
        </Tooltip.Trigger>
        <Tooltip.Box align="right" className="w-56">
          {placeholder('descriptions.howWishlistWorks')}
        </Tooltip.Box>
      </Tooltip.Root>
    </Heading>
    <Text>{placeholder('titles.wishlistKeywordsSuggestionsText')}</Text>
    <Keywords gaEventCategory={gaEventCategory} keywords={keywords} />
  </div>
);

WishlistSuggestions.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  keywords: PropTypes.arrayOf(PropTypes.string),
};

export default memo(WishlistSuggestions);
